import type { NodeItem } from '@octopus-do/octopus-project-core'
import { thunkUpdateNodeUrl } from '@store/migrationActions/thunkActions/thunkNodesActions'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import {
  InternalSeoActions,
  type SeoActions,
} from '@store/reducers/seo/actions'
import type { SeoFormValues } from '@store/reducers/seo/types'
import { put, select } from 'redux-saga/effects'

import { legacySeoUrlToAdopt } from '../utils'

export function* init({ payload }: ReturnType<typeof SeoActions.init>) {
  const node: NodeItem = yield select(
    migrationProjectSelector.getProjectNodeById(payload)
  )

  // OCT-4991: у страницы один адрес — node.url. Старый notes.seoUrl
  // переносим сюда, если адреса ещё нет, и больше никогда не пишем.
  const adopted = legacySeoUrlToAdopt(node.url, node.notes?.seoUrl)

  if (adopted !== null) {
    yield put(thunkUpdateNodeUrl(payload, adopted))
  }

  const seoFormValues: SeoFormValues = {
    title: node.notes?.seoTitle || '',
    description: node.notes?.seoDescription || '',
    slug: node.notes?.seoSlug || '',
    image: node.notes?.seoImage || null,
    h1_header: node.notes?.seoH1 || '',
    note: node.notes?.note || '',
    url: adopted ?? node.url ?? '',
    keywords: node.notes?.keywords || '',
    pageIntent: node.notes?.pageIntent || '',
  }

  yield put(InternalSeoActions.init(seoFormValues))
}
